<template>
  <div
    class="financial-selector__footer"
  >
    <div class="financial-selector__footer-container">
      <p class="financial-selector__footer-header">
        Your Security Is Our Top Priority
      </p>
      <div class="financial-selector__footer-body">
        <div class="flex">
          <img
            class="mx-10 pb-80"
            :src="require('@/assets/svg/plaid/lock.svg')"
          >
          <div class="mx-20">
            <p class="font-semibold text-base">
              Your privacy is protected
            </p>
            <p class="mt-5">
              We use bank level encryption to to transfer your information (SHA.256)
            </p>
          </div>
        </div>
        <div class="flex">
          <img
            class="mx-10 pb-70 sm:pb-20"
            :src="require('@/assets/svg/plaid/security.svg')"
          >
          <div class="mt-20 mx-20">
            <p class="font-semibold text-base">
              Your data belongs to you
            </p>
            <p class="mt-5">
              Your information is always handled with care and will only be used with your permission.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinancialSelectorFooter'
}
</script>

<style lang="scss" scoped>
.financial-selector__footer {
  @apply border-t-2;

  &-container {
    @apply max-w-600 mx-auto;
  }

  &-header {
    @apply mt-30 mb-20 text-xl text-center font-bold text-purple-500;
  }

  &-body {
    background-color: #f8f8ff;

    @apply p-30;
  }
}
</style>
